import { Injectable } from '@angular/core';

import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';

@Injectable({
  providedIn: 'root'
})
export class DescriptiveAnalysisService {

  constructor(private _httpGuard: HttpGuardService,) { }

  /**
   * Gets pad wear
   * @param entityId 
   * @param isMock 
   * @param classType 
   * @returns  
   */
  getPadWear(entityId: string, isMock: boolean, classType: string) {
    const payload = {
      entityId: entityId,
      class: classType,
      count: 1000,
      attributes: ['distance', 'wearRate'],
      isMock: isMock
    };
    return this._httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.padWear, payload, false);
  }

  /**
   * Gets brake event
   * @param entityId 
   * @param isMock 
   * @param classType 
   * @returns  
   */
  getBrakeEvent(entityId: string, isMock: boolean, classType: string) {
    const payload = {
      entityId: entityId,
      class: classType,
      isMock: isMock
    };
    return this._httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.brakeEvent, payload, false);
  }

  /**
   * Gets brake event group
   * @param entityId 
   * @param isMock 
   * @param classType 
   * @returns  
   */
  getBrakeEventGroup(entityId: string, isMock: boolean, classType: string) {
    const payload = {
      entityId: entityId,
      class: classType,
      isMock: isMock
    };
    return this._httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.brakeEventGroup, payload, false);
  }
}
